import { RegionId } from '../RegionUtilities';

/**
 * Markets whose meal plan pricing and merchandising are borrowed from the region that supplies them.
 *
 * Houston and Dallas are served entirely by Austin shefs over line drives, so they have no pricing
 * curve, ops ranking rows or add-on configuration of their own. Resolving them to Austin reuses its,
 * and because meal plan types are scoped by a region array in the database, resolving before the
 * query means those rows already match — no per-market backfill.
 *
 * Deliberately NOT applied to delivery days or region eligibility: Texas delivers Monday and Sunday
 * where Austin delivers Monday, Tuesday and Sunday, and those regions have to be real to be
 * eligible at all.
 */
const MEAL_PLAN_MERCHANDISING_REGION_BY_REGION: Readonly<Record<number, number>> = {
  [RegionId.Houston]: RegionId.Austin,
  [RegionId.Dallas]: RegionId.Austin,
};

export const getMealPlanMerchandisingRegionId = (regionId: number): number =>
  MEAL_PLAN_MERCHANDISING_REGION_BY_REGION[regionId] ?? regionId;
